import { types } from 'mobx-state-tree';

const Metadata = types.model({
  display_status: types.boolean,
  accuracy: types.maybeNull(types.string),
  fill_line: types.maybeNull(types.boolean),
  head_volume_disabled: types.maybeNull(types.boolean),
});

export const Container = types.model({
  id: types.integer,
  name: types.string,
  nickname: types.maybeNull(types.string),
  establishment_id: types.maybeNull(types.integer),
  type_code: types.integer,
  volume_unit_id: types.number,
  volume_total: types.number,
  archived: types.boolean,
  metadata: types.maybeNull(Metadata),
  head_space_pct: types.maybeNull(types.number),
  _volume_total_ml: types.maybeNull(types.number),
});
